import React, { useState, useEffect } from 'react';
import { Grid, Card, CardContent, Typography, Box, Modal, IconButton, Fade } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useSpring, animated } from 'react-spring';

const ProductComponent = ({ products, onSelectProduct, selectedCategory, selectedFilter }) => {
    const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth);

    // ADDED: slide modal state
    const [openImageModal, setOpenImageModal] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);

    useEffect(() => {
        const handleOrientationChange = () => {
            setIsPortrait(window.innerHeight > window.innerWidth);
        };

        window.addEventListener('resize', handleOrientationChange);
        return () => window.removeEventListener('resize', handleOrientationChange);
    }, []);

    // ADDED: keyboard navigation for modal
    const handleKeyDown = (e) => {
        if (e.key === 'ArrowLeft') handlePrevImage();
        else if (e.key === 'ArrowRight') handleNextImage();
        else if (e.key === 'Escape') setOpenImageModal(false);
    };

    useEffect(() => {
        if (openImageModal) {
            window.addEventListener('keydown', handleKeyDown);
            return () => window.removeEventListener('keydown', handleKeyDown);
        }
    }, [openImageModal, selectedImageIndex]);

    // ADDED: expand slide products into individual image cards
    const expandedProducts = [];
    const imageProducts = [];

    [...products].forEach(product => {
        if (product.type === 'slide' && product.images && product.images.length > 0) {
            product.images.forEach((image, index) => {
                const expandedProduct = {
                    ...product,
                    id: `${product.id}_img_${index}`,
                    currentImage: image.image_url,
                    imageIndex: index,
                    isImageProduct: true
                };
                expandedProducts.push(expandedProduct);
                imageProducts.push(expandedProduct);
            });
        } else {
            expandedProducts.push({ ...product, isImageProduct: false });
        }
    });

    const getProductImageSrc = (imagePath) => {
        if (!imagePath) return '';

        if (imagePath.startsWith('http')) {
            return imagePath;
        }

        if (imagePath.startsWith('/')) {
            return imagePath;
        }

        if (imagePath.startsWith('img/')) {
            return `/${imagePath}`;
        }

        if (imagePath.startsWith('media/')) {
            return `/${imagePath}`;
        }

        return `/img/${imagePath}`;
    };

    const handlePrevImage = () => {
        setSelectedImageIndex(prev => prev === 0 ? imageProducts.length - 1 : prev - 1);
    };

    const handleNextImage = () => {
        setSelectedImageIndex(prev => prev === imageProducts.length - 1 ? 0 : prev + 1);
    };

    // ADDED: handle click — slides open modal, products go to cart
    const handleProductClick = (product) => {
        if (product.isImageProduct) {
            const index = imageProducts.findIndex(p => p.id === product.id);
            setSelectedImageIndex(index);
            setOpenImageModal(true);
        } else {
            onSelectProduct(product);
        }
    };

    const animatedProps = useSpring({
        from: { opacity: 0, transform: 'scale(0.9)' },
        to: { opacity: 1, transform: 'scale(1)' },
        config: { tension: 280, friction: 20 },
    });

    const ProductCard = ({ product, onClick, selectedFilter }) => {
        const animatedProps = useSpring({
            from: { opacity: 0, transform: 'scale(0.9)' },
            to: { opacity: 1, transform: 'scale(1)' },
            config: { tension: 280, friction: 20 },
        });

        console.log(
            product.isImageProduct,
            product.currentImage
        )

        return (
            // <animated.div style={animatedProps}>
            <Card
                onClick={onClick}
                sx={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    position: 'relative',
                    height: product.isImageProduct ? 150 : '100%',
                    minHeight: product.isImageProduct ? 150 : 120,
                    boxShadow: 'none',
                }}
            >
                {product.isImageProduct ? (
                    // <Box sx={{
                    //     height: 150,
                    //     width: '100%',
                    //     backgroundImage: `url(${encodeURI(
                    //         product.currentImage.startsWith('http')
                    //             ? product.currentImage
                    //             : `/${product.currentImage}`
                    //     )})`,
                    //     backgroundSize: 'cover',
                    //     backgroundPosition: 'center',
                    // }} />
                    <Box sx={{ height: 150, width: '100%', overflow: 'hidden' }}>
                        <img
                            src={getProductImageSrc(product.currentImage)}
                            alt={product.name}
                            style={{
                                width: '100%',
                                height: '150px',
                                objectFit: 'cover',
                                backgroundPosition: 'center',
                                transition: 'all 0.3s ease-in-out'
                            }}
                        />
                    </Box>
                ) : (
                    <CardContent sx={{
                        userSelect: 'none',
                        minHeight: '120px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: 'fit-content',
                        boxShadow: 'none !important',
                    }}>
                        <img
                            src={getProductImageSrc(product.image_path)}
                            alt={product.name}
                            style={{ maxWidth: '100%', height: selectedFilter === 3 ? '200px' : 'auto', marginBottom: '8px' }}
                        />
                        <Typography variant="body2" color="textSecondary" sx={{ fontSize: 'clamp(16px, 2vw, 20px)' }}>
                            {product.price10x != null
                                ? `R$${parseFloat(product.price10x).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                : ''}
                        </Typography>
                    </CardContent>
                )}
            </Card>
            // </animated.div>
        );
    };

    return (
        <>
            <Grid container spacing={2} sx={{ padding: '0 25px 25px 25px' }}>
                <div>
                    {/* <Typography variant="h6" style={{ fontWeight: 600, textAlign: 'center', fontSize: '1.2rem', color: '#333', }}>{selectedCategory.name} </Typography> */}
                </div>
                {expandedProducts.map((product) => (
                    <Grid
                        item
                        key={product.id}
                        xs={isPortrait ? 6 : 2.4}
                        sm={isPortrait ? 6 : 2.4}
                        md={isPortrait ? 4 : 2.4}
                        lg={isPortrait ? 4 : 2.4}
                        style={{ maxWidth: isPortrait ? '50%' : '20%', flexBasis: isPortrait ? '50%' : '20%' }}>
                        <ProductCard
                            product={product}
                            onClick={() => handleProductClick(product)}
                            selectedFilter={selectedFilter}
                        />
                    </Grid>
                ))}
            </Grid>

            {/* ADDED: slide image modal with navigation */}
            <Modal
                open={openImageModal}
                onClose={() => setOpenImageModal(false)}
                closeAfterTransition
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.9)'
                }}
            >
                <Fade in={openImageModal} timeout={400}>
                    <Box sx={{ position: 'relative', width: '90vw', height: '90vh', outline: 'none' }}>
                        <IconButton
                            onClick={() => setOpenImageModal(false)}
                            sx={{
                                position: 'absolute', top: 10, right: 10,
                                backgroundColor: 'rgba(255, 255, 255, 0.9)', zIndex: 3,
                                '&:hover': { backgroundColor: 'rgba(255, 255, 255, 1)', transform: 'scale(1.1)' },
                                transition: 'all 0.2s ease-in-out'
                            }}
                        >
                            <CloseIcon />
                        </IconButton>

                        {imageProducts.length > 1 && (
                            <IconButton
                                onClick={handlePrevImage}
                                sx={{
                                    position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)',
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)', zIndex: 3,
                                    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 1)', transform: 'translateY(-50%) scale(1.1)' },
                                    transition: 'all 0.2s ease-in-out'
                                }}
                            >
                                <ArrowBackIosNewIcon />
                            </IconButton>
                        )}

                        {imageProducts.length > 1 && (
                            <IconButton
                                onClick={handleNextImage}
                                sx={{
                                    position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)', zIndex: 3,
                                    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 1)', transform: 'translateY(-50%) scale(1.1)' },
                                    transition: 'all 0.2s ease-in-out'
                                }}
                            >
                                <ArrowForwardIosIcon />
                            </IconButton>
                        )}

                        <Box
                            component="img"
                            src={getProductImageSrc(imageProducts[selectedImageIndex]?.currentImage)}
                            alt="Imagem ampliada"
                            sx={{ width: '100%', height: '100%', objectFit: 'contain', transition: 'opacity 0.3s ease-in-out' }}
                        />

                        {imageProducts.length > 1 && (
                            <Box sx={{
                                position: 'absolute', bottom: 20, left: '50%', transform: 'translateX(-50%)',
                                backgroundColor: 'rgba(0, 0, 0, 0.7)', color: 'white',
                                padding: '8px 16px', borderRadius: '20px', fontSize: '14px'
                            }}>
                                {selectedImageIndex + 1} / {imageProducts.length}
                            </Box>
                        )}
                    </Box>
                </Fade>
            </Modal>
        </>
    );
};

export default ProductComponent;